var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSideBarMenuApplicationManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "om8ni3plma"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.275000 0 0 0 0 0.327941 0 0 0 0 0.500000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -11)",
    filter: "url(#om8ni3plma)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.578 33H24a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2.467h0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1,2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.438 29.039c.022-.176.038-.352.038-.539 0-.187-.016-.363-.038-.539l1.16-.907a.277.277 0 0 0 .066-.352l-1.1-1.904a.276.276 0 0 0-.335-.12l-1.37.55a4.018 4.018 0 0 0-.93-.54l-.208-1.457a.268.268 0 0 0-.27-.231h-2.2a.268.268 0 0 0-.27.231l-.208 1.457a4.226 4.226 0 0 0-.93.54l-1.37-.55a.268.268 0 0 0-.335.12l-1.1 1.904a.271.271 0 0 0 .066.351l1.16.908a4.362 4.362 0 0 0-.038.539c0 .181.017.363.039.539l-1.16.907a.277.277 0 0 0-.067.352l1.1 1.903a.276.276 0 0 0 .336.121l1.37-.55c.285.22.593.402.929.54l.209 1.457a.268.268 0 0 0 .27.231h2.2a.268.268 0 0 0 .269-.231l.209-1.457c.335-.138.643-.325.93-.54l1.369.55c.126.05.27 0 .335-.12l1.1-1.903a.277.277 0 0 0-.066-.352l-1.16-.908zm-4.087 1.386a1.927 1.927 0 0 1-1.925-1.925c0-1.062.864-1.925 1.925-1.925 1.062 0 1.925.863 1.925 1.925a1.927 1.927 0 0 1-1.925 1.925z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSideBarMenuApplicationManagement);
export default __webpack_public_path__ + "static/media/ico-side-bar-menu-application-management.c2ebc8c0cc72a1da7f0306fca061f0d9.svg";
export { ForwardRef as ReactComponent };